<div class="ov ov--light">
  <header class="ov-head">
    <h1>{{ t('ffNav.overview', 'Сводка') }}</h1>
    <p>{{ t('ffOverview.subtitle', 'Главное на сегодня по вашим сделкам и ставкам') }}</p>
  </header>

  <div *ngIf="loading" class="pp-card"><div class="pp-loading">{{ t('common.loading', 'Загрузка...') }}</div></div>

  <ng-container *ngIf="!loading">
    <!-- Плитки с цифрами -->
    <section class="ov-tiles">
      <a class="ov-tile" routerLink="/freight-forwarder/dashboard/deals">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>
        <small>{{ t('ffOverview.activeDeals', 'Сделки в работе') }}</small>
        <strong>{{ activeDeals.length }}</strong>
        <span>{{ t('ffOverview.toDeals', 'Мои сделки') }} ›</span>
      </a>
      <a class="ov-tile" [class.ov-tile--warn]="needUpdate.length > 0" routerLink="/freight-forwarder/dashboard/deals">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg></span>
        <small>{{ t('ffOverview.needUpdate', 'Статус не обновлён сегодня') }}</small>
        <strong>{{ needUpdate.length }}</strong>
        <span>{{ t('ffOverview.until13', 'Обновите до 13:00') }}</span>
      </a>
      <a class="ov-tile" routerLink="/freight-forwarder/dashboard/bids">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg></span>
        <small>{{ t('ffOverview.pendingBids', 'Ставки ждут решения') }}</small>
        <strong>{{ pendingBids }}</strong>
        <span *ngIf="winRate !== null">{{ t('ffOverview.winPct', 'Выиграно {n}%').replace('{n}', '' + winRate) }}</span>
        <span *ngIf="winRate === null">{{ t('ffOverview.toBids', 'Мои ставки') }} ›</span>
      </a>
      <a class="ov-tile ov-tile--accent" routerLink="/freight-forwarder/requests">
        <span class="ov-tile__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg></span>
        <small>{{ t('ffOverview.openRequests', 'Новые запросы') }}</small>
        <strong>{{ openRequests ?? '—' }}</strong>
        <span>{{ t('ffOverview.findRequests', 'Найти и сделать ставку') }} ›</span>
      </a>
    </section>

    <!-- Итоги за всё время -->
    <section class="pp-card ov-stats ov-stats--8">
      <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg></span>{{ t('ffOverview.totals', 'Итоги') }}</h2>
      <dl>
        <div>
          <dt>{{ t('ffOverview.dealsTotal', 'Всего сделок') }}</dt>
          <dd>{{ deals.length }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.preparing', 'Подготовка') }}</dt>
          <dd>{{ preparingCount }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.inTransit', 'В пути') }}</dt>
          <dd>{{ inTransitCount }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.delivered', 'Доставлено') }}</dt>
          <dd>{{ deliveredCount }}</dd>
        </div>
        <div>
          <dt>{{ t('ffOverview.totalWeight', 'Общий вес грузов') }}</dt>
          <dd>{{ totalWeightText }}</dd>
          <small class="ov-stats__hint">{{ t('ffOverview.deliveredOnly', 'доставленных') }}</small>
        </div>
        <div>
          <dt>{{ t('ffOverview.totalFreight', 'Стоимость перевозок') }}</dt>
          <dd>{{ totalFreightText }}</dd>
          <small class="ov-stats__more" *ngIf="totalFreightOthers">{{ totalFreightOthers }}</small>
          <small class="ov-stats__hint">{{ t('ffOverview.byInvoices', 'по выставленным счетам') }}</small>
        </div>
        <div>
          <dt>{{ t('ffOverview.bidsTotal', 'Ставок сделано') }}</dt>
          <dd>{{ bids.length }}</dd>
        </div>
      </dl>
    </section>

    <div class="ov-grid">
      <!-- Требует внимания -->
      <section class="pp-card ov-card">
        <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 16V11a6 6 0 0 1 12 0v5l2 2H4z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg></span>{{ t('ffOverview.attention', 'Требует внимания') }}</h2>
        <p class="ov-empty" *ngIf="!hasAttention">
          {{ activeDeals.length ? t('ffOverview.allUpdated', 'Все статусы сегодня обновлены. Отлично!') : t('ffOverview.noActive', 'Сделок в работе пока нет.') }}
        </p>
        <ul class="ov-list" *ngIf="hasAttention">
          <li *ngFor="let d of needUpdate">
            <a [routerLink]="['/freight-forwarder/deal', d.id]">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ d.stage }}</small>
              </span>
              <span class="ov-list__action">{{ t('ffOverview.update', 'Обновить статус') }} ›</span>
            </a>
          </li>
          <!-- Задолженность клиента по выставленным счетам -->
          <li *ngFor="let d of withDebt">
            <a [routerLink]="['/freight-forwarder/deal', d.id]">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ t('ffOverview.unpaid', 'Не оплачено по счетам') }}</small>
              </span>
              <span class="ov-list__action ov-list__action--debt">{{ dealTotals(d.totals, 'debt') }} ›</span>
            </a>
          </li>
          <!-- Переплата клиента -->
          <li *ngFor="let d of withOverpay">
            <a [routerLink]="['/freight-forwarder/deal', d.id]">
              <span class="ov-list__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ t('ffOverview.overpaid', 'Переплата клиента') }}</small>
              </span>
              <span class="ov-list__action ov-list__action--over">{{ dealTotals(d.totals, 'overpaid') }} ›</span>
            </a>
          </li>
        </ul>
      </section>

      <!-- Последние ставки -->
      <section class="pp-card ov-card">
        <div class="ov-card__head">
          <h2><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg></span>{{ t('ffOverview.latestBids', 'Последние ставки') }}</h2>
          <a routerLink="/freight-forwarder/dashboard/bids">{{ t('ffOverview.all', 'Все') }} ›</a>
        </div>
        <p class="ov-empty" *ngIf="latestBids.length === 0">{{ t('ffOverview.noBids', 'Вы ещё не делали ставок.') }}</p>
        <ul class="ov-list" *ngIf="latestBids.length > 0">
          <li *ngFor="let b of latestBids">
            <a [routerLink]="['/freight-forwarder/request', b.cargoRequestId]" [queryParams]="{ returnTo: 'dashboard' }">
              <span class="ov-list__main">
                <b>{{ b.id | docNo:'B':b.createdAt }} · {{ money(b.price, b.currencyCode) }}</b>
                <small>{{ t('ffDeal.requestDetails', 'Запрос') }} {{ b.cargoRequestId | docNo:'R':b.createdAt }} · {{ b.createdAt | date:'dd.MM.yyyy' }}</small>
              </span>
              <span class="pp-badge" [ngClass]="'pp-badge--' + bidTone(b)">{{ bidStatusText(b) }}</span>
            </a>
          </li>
        </ul>
      </section>
    </div>
  </ng-container>
</div>
